export default __webpack_public_path__ + "static/media/2008.c5954cb2.jpg";